import React from 'react';

import { PromoHeaderMobileSkeleton } from '@atlas/ui';

const HeaderSkeleton = ({ children, loading }) => {
  if (loading) {
    return <PromoHeaderMobileSkeleton />;
  }

  return children || null;
};

export default HeaderSkeleton;
